import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueInstagram from 'vue-instagram'
import { store } from './store/index.js'
import BootstrapVue from 'bootstrap-vue'
import firebase from 'firebase'
import router from './router/index'
import SocialSharing  from 'vue-social-sharing'

Vue.config.productionTip = false
Vue.use(VueInstagram)
Vue.use(BootstrapVue)
Vue.use(SocialSharing);


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/blog.css'

const firebaseConfig = {
  apiKey: "AIzaSyBKLngmhpBj7OZ4Z4SuOUsCV7WTvHOYB2o",
  authDomain: "instacash-3b45e.firebaseapp.com",
  databaseURL: "https://instacash-3b45e.firebaseio.com",
  projectId: "instacash-3b45e",
  storageBucket: "instacash-3b45e.appspot.com",
  messagingSenderId: "41341197097",
  appId: "1:41341197097:web:4fbd05fdd3483136077538",
  measurementId: "G-KK70HCJ7KL"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  vuetify,
  store,
  router,
  firebase,
  render: h => h(App)
}).$mount('#app')
